<template>
	<header class="header-app">
		<div class="shell">
			<div class="header__content">
				<a :href="logoUrl" class="logo-small">
					<img :src="logoImg" alt="">
				</a>

				<div class="header__content-inner">
					<h6>
						{{ heading }}
						<span>|</span>
						{{ date }}
					</h6>

					<p>
						{{ path }}
					</p>
				</div><!-- /.header__content-inner -->
			</div>

			<aside class="header__aside">
				<div class="steps">
					<div class="step" v-if="product.passengers !== null" >
						<p>
							Guests:
						</p>

						<h3>
							{{ product.passengers }}
						</h3>
					</div><!-- /.step -->

					<div class="step" v-if="currentDeck">
						<p>
							Deck:
						</p>

						<h3>
							{{ currentDeck[0].title }}
						</h3>
					</div><!-- /.step -->

					<div class="step" v-if="currentCabin">
						<p>
							Cabin:
						</p>

						<h3>
							{{ currentCabin[0].number }}
						</h3>
					</div><!-- /.step -->

					<div class="step step--big" v-if="currentCabin">
						<p>Total Due at Booking</p>

						<h3>$ {{ Number(totalPrice).toLocaleString() }}</h3>
					</div><!-- /.step -->
				</div><!-- /.nav-steps -->
			</aside><!-- /.header__aside -->
		</div><!-- /.shell -->
	</header><!-- /.header -->
</template>

<script>
/**
 * Internal Dependencies
 */
import { mapGetters } from 'vuex';
import numberFormat from '../mixins/number-format';

export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'the-header',

	mixins: [numberFormat],

	data() {
		return {
			logoImg: crb_app.app_data.logo_img,
			logoUrl: crb_app.app_data.logo_url,
			heading: crb_app.app_data.heading,
			date: crb_app.app_data.date,
			path: crb_app.app_data.path,

			fee_product_price: crb_booking_app.fee_product_price
		};
	},

	computed: {
		/**
		 * Map Store Getters
		 */
		...mapGetters({
			'product':'getProduct',
			'decks':'getDecks'
		}),

		currentDeck(){
			if (this.product.deck === null || this.decks == undefined ) {
				return false
			}

			const currentDeck = this.decks.filter(deck => deck.id === this.product.deck)

			return currentDeck
		},

		currentCabin(){
			if (this.product.cabin === null || this.product.deck === null || this.decks == undefined) {
				return false
			}
			const currentCabin = this.currentDeck[0].cabins.filter(cabin => cabin.id === this.product.cabin)

			return currentCabin
		},

		totalPrice() {
			var current_fee_product_price;

			if ( ( this.product.passengers - 2 ) > 0 ) {
				current_fee_product_price = this.fee_product_price * ( this.product.passengers - 2 );
			} else {
				current_fee_product_price = 0;
			}

			if ( crb_app.app_data.deposit_status ) {
				return this.formatNumber( ( parseFloat(this.currentCabin[0].gratuity) + parseFloat(this.currentCabin[0].port_taxes) ) * this.product.passengers + ( parseFloat(this.currentCabin[0].price) + parseFloat(current_fee_product_price) ) * ( parseFloat(crb_booking_app.deposit_percentage) * 0.01 ) )
			} else {
				return this.formatNumber( ( parseFloat(this.currentCabin[0].price) + parseFloat(current_fee_product_price) ) * ( parseFloat(crb_booking_app.deposit_percentage) * 0.01 ) )
			}
		}
	},

};
</script>



// WEBPACK FOOTER //
// src/components/TheHeader.vue